import { Component, OnInit } from '@angular/core';
import { HomeService } from '../../services/home.service';
import { Router, NavigationEnd } from '@angular/router';
 
@Component({
  selector: 'app-stores-list',
  templateUrl: './stores-list.component.html',
  styleUrls: ['./stores-list.component.scss', '../../../app.component.scss']
})
export class StoresListComponent implements OnInit{
  route: any;
  totalStoreCount: number = 0;
  activeTab: string = 'stores';

  constructor(public homeService: HomeService, private router: Router) { }

  public storeId = "";
  public storeDetails: any = []
  public deviceId: any;
 
  ngOnInit(): void { 
    this.getStoreDetails(); 
    this.router.events.subscribe(event => {
      if (event instanceof NavigationEnd) {
        // Update active tab based on current route
        this.updateActiveTab();
      }
    });
  }

  getStoreDetails(){
    this.homeService.getStoreDetails().subscribe((res)=>{
      if (res.data) {
        this.storeDetails = res.data;
        this.totalStoreCount = this.storeDetails.length;
      }
    });
  }

  updateActiveTab(): void {
    const currentUrl = this.router.url;
    if (currentUrl.includes('home/stores')) {
      this.activeTab = 'stores';
    } else if (currentUrl.includes('home/warehouses')) {
      this.activeTab = 'warehouses';
    } else if (currentUrl.includes('home/alerts-notify')){
      this.activeTab = 'alerts';
    }
  }

  setActiveTab(tab: string): void {
    this.activeTab = tab;
    // Update route based on active tab
    switch (tab) {
      case 'alerts':
        this.router.navigate(['home/alerts-notify']);
        break;
      case 'stores':
        this.router.navigate(['home/stores']);
        break;
      case 'warehouse':
        this.router.navigate(['home/warehouses']);
        break;
      default:
        break;
    }  
  }

 
  // getDeviceLink(storeId: string): string {
  //   if (this.activeTab === 'cabinets') {
  //     return `/home/stores/${storeId}/cabinets`;
  //   } else if (this.activeTab === 'desktop') {
  //     return `/home/stores/${storeId}/devices`;
  //   } else {
  //     return `/home/stores/${storeId}/handheld`;
  //   }
  // }

  getDeviceLink(storeId: string): string {
    switch (this.activeTab) {
      case 'cabinets':
        return `/home/stores/${storeId}/devices`;
      case 'handheld':
        return `/home/stores/${storeId}/handheld`;
      default:
        return `/home/stores/${storeId}/cabinets`;
    }
  }

  
  

}
   


